module.exports = __webpack_public_path__ + "media/gift/desktop_phones-86dc4c0c.png";